import { render, staticRenderFns } from "./tourist.vue?vue&type=template&id=bdc56c36&scoped=true&"
import script from "./tourist.vue?vue&type=script&lang=js&"
export * from "./tourist.vue?vue&type=script&lang=js&"
import style0 from "./tourist.vue?vue&type=style&index=0&id=bdc56c36&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc56c36",
  null
  
)

component.options.__file = "tourist.vue"
export default component.exports